<section class="w-full h-full bg-[#FAFAFA] md:px-10 md:py-16 px-4 py-8">
  <div class="container mx-auto w-full h-full">
    <div
      appScrollAnimate="animate-fade-in-up"
      [scrollThreshold]="0"
      class="flex flex-col items-center justify-center py-10"
    >
      <h2 i18n="organizer.line|All inside LINE headline@@organizer.line.title1" class="text-xl md:text-3xl font-bold text-black tracking-wide">All inside LINE</h2>
      <h2 i18n="organizer.line|In one simple system headline@@organizer.line.title2" class="text-xl md:text-3xl font-bold text-black tracking-wide">In one simple system</h2>
    </div>
  </div>
</section>
